import { render, staticRenderFns } from "./RecoTypeList.vue?vue&type=template&id=381fef68&"
import script from "./RecoTypeList.vue?vue&type=script&lang=js&"
export * from "./RecoTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports